/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { 社員_乗務員 } from "../../../constant/enum/codes"
import { e休日区分 } from "../../../constant/enum/master"
import { e社員区分 } from "../../../constant/enum/syain"
import { e勤怠区分, 勤怠表示記号区分 } from "../../../constant/enum/unko"
import { メニューコード } from "../../../constant/menuCode"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import SyukkinboService from "../../../service/attendance/syukkinbo/syukkinboService"
import {
  TSyukkinboListGetReq,
  TSyukkinboListGetRes,
} from "../../../service/attendance/syukkinbo/TSyukkinbo"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import kengenUtil from "../../../ts/util/kengenUtil"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { e部所権限コード } from "../../../constant/kengenCode"

// #region [type]

export type T出勤簿リスト = TSyukkinboListGetRes & { 行ID: symbol }

//#endregion

/**
 * 出勤簿一覧
 * @returns
 */
const SyukkinboList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector(
    (rootState: RootState) => rootState.date.eigyobiStr
  )
  const userInfo = useSelector(
    (rootState: RootState) => rootState.user.LoginUserInfo
  )

  const has変更可能権限 = kengenUtil.出勤簿変更可能権限判定(userInfo)

  const 個人社員区分List: string[] = [e社員区分.事務員, e社員区分.運行部員]

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)
  const ref年月 = useRef<string>(eigyobi)
  const ref日曜日 = useRef<string>()
  const ref日数 = useRef<number>(0)
  const 勤怠記号DataMap = new wjcGrid.DataMap<{
    区分コード: string
    表示記号: string
  }>(勤怠表示記号区分, "区分コード", "表示記号")

  // 休日対応
  let refHolidayList = useRef<Array<{ 休日: string }>>([])
  // 所定休日対応
  let refSyoteidayList = useRef<Array<{ 休日: string }>>([])

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SyukkinboList_GridId"

  //#region [method]

  /**
   * 検索条件の年月から対象月の日数を返却
   */
  const getLastDay = () => {
    const endDate = dayjs(ref年月.current).add(1, "month").date(0).toDate()
    const lastDay = dayjs(endDate).format("DD")
    return parseInt(lastDay)
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyukkinboListGetRes>,
    pageSize: number
  ) => {
    // 日付Column設定
    let 日付リスト: any = {}
    // 当月分の日数リスト
    let dList: number[] = []
    // 当月の最大日数取得
    let cnt = getLastDay()
    // 当月の日数分を日数リストへ格納
    for (let k = 1; k < cnt + 1; k++) {
      dList.push(k)
    }

    // 日数リスト分のColumn設定を日付リストへ格納する
    dList.forEach((element: number) => {
      日付リスト[`day_${element}`] = (i: TSyukkinboListGetRes) => {
        // 日数リストの日付とItemSourceの日付を比較
        const kubun = i.社員区分コード
        const target = i.勤怠リスト.find((item) => {
          // 勤務日から日付のみ取得
          let d = parseInt(dayjs(item.勤務日).format("D"))

          return element === d
        })
        if (!target) return ""

        if (!勤怠区分ItemSource) return ""
        const kigo = 勤怠区分ItemSource
          .filter((d) => d.分類コード === "U0002")
          .filter((m) => {
            if (kubun === e社員区分.乗務員) {
              if (m.数値1 === parseInt(kubun)) {
                return true
              }
              return false
            } else {
              return true
            }
          })
          .filter((k) => k.区分コード === target.勤怠区分コード)

        try {
          return kigo[0].区分コード
        } catch (error) {
          return ""
        }
      }
    })

    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        // TODO:カレンダーをdayjs使う＆祝日カレンダー（DB)の値で休みか判定する必要ある。
        出勤日数_出勤: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (
              d.勤怠区分コード === e勤怠区分.出勤 ||
              d.勤怠区分コード === e勤怠区分.午前半休 ||
              d.勤怠区分コード === e勤怠区分.午後半休
            )
              cnt = cnt + 1
          })
          return cnt
        },
        出勤日数_休出: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (
              (d.勤怠区分コード === e勤怠区分.出勤 ||
                d.勤怠区分コード === e勤怠区分.午前半休 ||
                d.勤怠区分コード === e勤怠区分.午後半休) &&
              d.日曜フラグ === 1
            )
              cnt = cnt + 1
          })
          return cnt
        },
        休暇取得_有給: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.有給休暇) cnt = cnt + 1
            if (
              d.勤怠区分コード === e勤怠区分.午前半休 ||
              d.勤怠区分コード === e勤怠区分.午後半休
            )
              cnt = cnt + 0.5
          })
          return cnt
        },
        休暇取得_特休: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.特別休暇) cnt = cnt + 1
          })
          return cnt
        },
        休暇取得_育介: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.育介休暇) cnt = cnt + 1
            if (d.勤怠区分コード === e勤怠区分.育介半休) cnt = cnt + 0.5
          })
          return cnt
        },
        休暇取得_欠勤: (i: TSyukkinboListGetRes) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.欠勤) cnt = cnt + 1
          })
          return cnt
        },
        就労時間_就労: (i: TSyukkinboListGetRes) => {
          let total = i.勤怠リスト.reduce(
            (result, row) =>
              result + parseInt(row.勤務時間 ? row.勤務時間 : "0"),
            0
          )
          const hour = Math.floor(total / 3600000)
          const min = Math.floor((total % 3600000) / 60000)
          return hour + min > 0 ? hour + ":" + ("00" + min).slice(-2) : 0
        },
        就労時間_残業: (i: TSyukkinboListGetRes) => {
          let total = i.勤怠リスト.reduce(
            (result, row) =>
              result + parseInt(row.残業時間 ? row.残業時間 : "0"),
            0
          )
          const hour = Math.floor(total / 3600000)
          const min = Math.floor((total % 3600000) / 60000)
          return hour + min > 0 ? hour + ":" + ("00" + min).slice(-2) : 0
        },
        就労時間_深夜: (i: TSyukkinboListGetRes) => {
          let total = i.勤怠リスト.reduce(
            (result, row) =>
              result + parseInt(row.深夜時間 ? row.深夜時間 : "0"),
            0
          )
          const hour = Math.floor(total / 3600000)
          const min = Math.floor((total % 3600000) / 60000)
          return hour + min > 0 ? hour + ":" + ("00" + min).slice(-2) : 0
        },
        就労時間_休日: (i: TSyukkinboListGetRes) => {
          let total = i.勤怠リスト.reduce(
            (result, row) =>
              result + parseInt(row.休出時間 ? row.休出時間 : "0"),
            0
          )
          const hour = Math.floor(total / 3600000)
          const min = Math.floor((total % 3600000) / 60000)
          return hour + min > 0 ? hour + ":" + ("00" + min).slice(-2) : 0
        },
        ...日付リスト,
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyukkinboListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    flexGrid?.select(-1, -1)

    let currentSearchCondition: TSyukkinboListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyukkinboService().getList(currentSearchCondition)
      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(
          res.data
            .filter((d) => d.社員区分コード !== e社員区分.乗務員)
            .sort((a, b) => {
              if (a.社員コード.padStart(4, "0") > b.社員コード.padStart(4, "0"))
                return 1
              if (a.社員コード.padStart(4, "0") < b.社員コード.padStart(4, "0"))
                return -1
              return 0
            }),
          pageSize
        ),
      })

      refHolidayList.current = []
      refSyoteidayList.current = []
      const kyuzituRes = await new KyuzituService().getList({
        検索年: currentSearchCondition.年月,
      })
      const SyukujizuRes = kyuzituRes.data.filter(
        (d) => d.休日区分コード === e休日区分.祝日
      )
      const syoteiRes = kyuzituRes.data.filter(
        (d) => d.休日区分コード === e休日区分.所定休日
      )
      SyukujizuRes.forEach((i) => {
        refHolidayList.current.push({
          休日: i.休日日付,
        })
      })
      syoteiRes.forEach((i) => {
        refSyoteidayList.current.push({
          休日: i.休日日付,
        })
      })
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false
    } catch (error) {
      dispatch(setAlerts(error))
      // dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyukkinboListGetReq = queryString.parse(location.search)

    if (!has変更可能権限) {
      query.部所コード = userInfo.部所コード
    }
    set年月(query.年月)
    set部所コード(query.部所コード ?? userInfo.部所コード ?? "")
    set社員区分コード(query.社員区分コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyukkinboListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
      社員区分コード: 社員区分コード ?? undefined,
      社員ID:
        !has変更可能権限 && 個人社員区分List.includes(userInfo.社員区分コード)
          ? userInfo.社員ID
          : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyukkinboListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    const disp社員区分 = 社員区分ItemSource?.find(
      (i) =>
        i.区分コード === searchCondition.社員区分コード &&
        i.分類コード === 社員_乗務員.社員区分
    )

    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
      社員区分: disp社員区分
        ? `${disp社員区分.区分コード} ${disp社員区分.名称1}`
        : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    ref年月.current = eigyobi
    ref日数.current = 0
    ref明細フォーマットフラグ.current = false

    set部所コード("")
    set部所(undefined)
    set部所ItemSource(undefined)

    set社員区分コード("")
    set社員区分(undefined)
    set社員区分ItemSource(undefined)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    const 所属binding = ["部所略称", "社員コード", "社員氏名"]
    let columnHeaders = f.columnHeaders

    // Date変換
    let targetDate = eigyobi
    if (ref年月.current != null) targetDate = ref年月.current
    // 対象の年月までを設定する
    let ymDate = dayjs(targetDate).format("YYYYMM")

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding != null) {
        if (所属binding.includes(c.binding)) {
          columnHeaders.setCellData(0, index, "所属")
        } else if (c.binding.includes("出勤日数")) {
          columnHeaders.setCellData(0, index, "出勤日数")
        } else if (c.binding.includes("休暇取得")) {
          columnHeaders.setCellData(0, index, "休暇取得")
        } else if (c.binding.includes("就労時間")) {
          columnHeaders.setCellData(0, index, "就労時間")
        } else if (c.binding.includes("時間外")) {
          columnHeaders.setCellData(0, index, "時間外")
        } else if (c.binding.includes("安全会議")) {
          columnHeaders.setCellData(0, index, "安全会議")
        }
      }
      // 日付部分
      // 対象月の日数取得
      let cnt = getLastDay()
      // 日数分の設定
      for (let i = 1; i < cnt + 1; i++) {
        let day = "day_" + i
        if (c.binding === day) {
          // 対象月のYYYYMMにDD部分を合わせる
          let target = ymDate + i
          // 曜日を取得
          let str = dayjs(target).format("ddd")
          columnHeaders.setCellData(0, index, i) // 日付
          columnHeaders.setCellData(1, index, str) // 曜日

          // 休日カレンダー判定
          let sundayCssClass = "holiday-color"
          let holidayCssClass = "syukkinbo-holiday-color"

          // css設定済みフラグ
          let isCssClass = false

          // columnの日付生成
          const ret = ("00" + i).slice(-2) // 0埋め
          const colDate = dayjs(targetDate).format("YYYY/MM") + "/" + ret

          const tmp曜日 = dayjs(colDate).format("ddd")

          // 祝日もしくは所定休日のであるかを判定
          const is休日 = [
            ...refSyoteidayList.current,
            ...refHolidayList.current,
          ].find((d) => dayjs(d.休日).format("YYYY/MM/DD") === colDate)

          // 列の日付が休日だった場合、CSSを設定する
          if (tmp曜日 === ref日曜日.current) {
            columnHeaders.columns[i + 12].cssClassAll = sundayCssClass
            isCssClass = true
          } else if (is休日 && !isCssClass) {
            columnHeaders.columns[i + 12].cssClassAll = holidayCssClass
            isCssClass = true
          } else {
            columnHeaders.columns[i + 12].cssClassAll = ""
          }
        }
      }

      c.allowMerging = true
      c.align = "center"
    })

    // フォーマットのループ制御
    ref明細フォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年月, set年月] = useState<string | null>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [社員区分コード, set社員区分コード] = useState<string | null>()
  const [, set社員区分] = useState<T区分マスタ | null>()
  const [社員区分ItemSource, set社員区分ItemSource] = useState<T区分マスタ[]>()

  const [勤怠区分ItemSource, set勤怠区分ItemSource] = useState<T区分マスタ[]>()

  //#region comboboxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  // 社員区分
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  const [isComboboxItemInitialized, setIsComboboxItemInitialised] =
    useState(false)

  //#endregion

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `出勤簿一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
    ref日数.current = getLastDay()
  }, [])

  useEffect(() => {
    if (!年月) return
    ref年月.current = 年月

    // 対象月の日数取得
    ref日数.current = getLastDay()
  }, [年月])

  // TODO: APIから取得する
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new KyuzituService().getList({ 検索年: eigyobi }),
    ]).then(([部所ListRes, 区分マスタRes, 休日マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set社員区分ItemSource(区分マスタRes.data)
      set勤怠区分ItemSource(区分マスタRes.data)

      const SyukujizuRes = 休日マスタRes.data.filter(
        (d) => d.休日区分コード === e休日区分.祝日
      )
      const syoteiRes = 休日マスタRes.data.filter(
        (d) => d.休日区分コード === e休日区分.所定休日
      )
      SyukujizuRes.forEach((i) => {
        refHolidayList.current.push({
          休日: i.休日日付,
        })
      })
      syoteiRes.forEach((i) => {
        refSyoteidayList.current.push({
          休日: i.休日日付,
        })
      })
      ref日曜日.current = "日"
      ref明細フォーマットフラグ.current = false
      setIsComboboxItemInitialised(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 部所ComboBox && isComboboxItemInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する

        set部所コード(userInfo.部所コード)
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所ComboBox, isComboboxItemInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">出勤簿一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                defaultValue={eigyobi}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                                autoFocus={true}
                              />
                            </div>
                            <ComboBox.Busyo
                              isRequired={true}
                              placeholder="部所"
                              isDisabled={!has変更可能権限}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              isAllSelect={has変更可能権限}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            <ComboBox.Kubun
                              placeholder="社員区分"
                              分類コード="H0001"
                              isLoadEnded={社員区分IsLoadEnded}
                              setIsLoadEnded={set社員区分IsLoadEnded}
                              isAllSelect={true}
                              itemsSource={社員区分ItemSource}
                              selectedValue={社員区分コード}
                              setSelectedValue={set社員区分コード}
                              ComboBox={社員区分ComboBox}
                              setComboBox={
                                set社員区分ComboBox
                              }></ComboBox.Kubun>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                hasFilter={false}
                gridProperties={{
                  frozenColumns: 3,
                  allowSorting: wjcGrid.AllowSorting.None,
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    <div className="ms-1 d-inline">
                      凡例:&nbsp;
                      <span className="ms-3 holiday-color">
                        赤字:&nbsp;日曜日
                      </span>
                      <span className="ms-3 syukkinbo-holiday-color">
                        青字:&nbsp;基本所定休日
                      </span>
                    </div>
                  </>
                }>
                {/* ここから固定列 Start */}
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  cssClass="text-start"
                  width={120}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  cssClass="text-start"
                  width={70}
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  cssClass="text-start"
                  width={128}
                  header="氏名">
                  {/* TODO:buttonじゃなくてaタグで遷移させたい。別Tab対応も考慮。 */}
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyukkinboListGetRes>
                    ) => {
                      // 本人もしくは部所権限が人事のみ遷移可能
                      const is遷移可 =
                        userInfo.社員ID === context.item.社員ID ||
                        userInfo.部所権限コード === e部所権限コード.人事 ||
                        userInfo.社員区分コード === e社員区分.システム管理者

                      return is遷移可 ? (
                        <button
                          className="link-button text-primary"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            const path = util.getMenuPath(
                              メニューコード.勤怠管理.出勤簿
                            )
                            history.push(
                              path[0]
                                .replaceAll(
                                  ":id",
                                  context.item.社員ID.toString()
                                )
                                .replaceAll(
                                  ":date",
                                  dayjs(ref年月.current).format("YYYY-MM-DD")
                                )
                            )
                          }}>
                          {context.item.社員氏名}
                        </button>
                      ) : (
                        <>{context.item.社員氏名}</>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                {/* ここまで固定列 End */}

                {/* 以下スクロール列 */}
                <wjrGrid.FlexGridColumn
                  binding="出勤日数_出勤"
                  cssClass="text-end"
                  width={50}
                  header="出勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="出勤日数_休出"
                  cssClass="text-end"
                  width={50}
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休暇取得_特休"
                  cssClass="text-end"
                  width={50}
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休暇取得_有給"
                  cssClass="text-end"
                  width={50}
                  header="有休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休暇取得_育介"
                  cssClass="text-end"
                  width={50}
                  header="育介"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="休暇取得_欠勤"
                  cssClass="text-end"
                  width={50}
                  header="欠勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_就労"
                  cssClass="text-end"
                  width={60}
                  header="就労"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_残業"
                  cssClass="text-end"
                  width={60}
                  header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_深夜"
                  cssClass="text-end"
                  width={60}
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_休日"
                  cssClass="text-end"
                  width={60}
                  header="休日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_1"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="1日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_2"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="2日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_3"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="3日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_4"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="4日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_5"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="5日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_6"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="6日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_7"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="7日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_8"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="8日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_9"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="9日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_10"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="10日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_11"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="11日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_12"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="12日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_13"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="13日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_14"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="14日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_15"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="15日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_16"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="16日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_17"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="17日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_18"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="18日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_19"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="19日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_20"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="20日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_21"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="21日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_22"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="22日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_23"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="23日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_24"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="24日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_25"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="25日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_26"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="26日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_27"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="27日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={28 <= ref日数.current}
                  binding="day_28"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="28日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={29 <= ref日数.current}
                  binding="day_29"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="29日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={30 <= ref日数.current}
                  binding="day_30"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="30日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={31 <= ref日数.current}
                  binding="day_31"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="31日"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SyukkinboList
